<div class="confirmation-modal-container display-flex flex-column">
  <h2 mat-dialog-title class="modal-header">Comment too long</h2>
  <mat-dialog-content>
    <div class="mb-10">Please reduce to {{ data }} characters.</div>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-end">
    <button mat-stroked-button color="primary" class="wp-80" (click)="cancel()">OK</button>
  </mat-dialog-actions>
</div>
